export class AuxiliaryInterpretedDataModel
{
    public ActivityCode: number;
    public Description: string;
    public IsInteresting: boolean;
    public IsManualStart: boolean;
    public IsOnHold: boolean;
    public IsRunning: boolean;
    public Number: number;
    public SecondsRemaining: number;
    public SecondsReported: number;
    public ShouldUseTimer: boolean;
    public Status: string;
    public TimeStamp: Date;

    constructor(json: object = null)
    {
        if (json)
        {
            // Map the json object to 'this' objects properties.
            Object.assign(this, json);
        }

        // Handle any custom mappings here or use getters and setters. Object.assign will call
        // property setters.
    }
}
